// Webpack Imports
import * as bootstrap from 'bootstrap';

(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});
})();


document.addEventListener('DOMContentLoaded', function () {
	const header = document.querySelector('#header');
	window.addEventListener('scroll', function () {
		if (window.scrollY > 131) {
			header.classList.add('scrolled');
		} else {
			header.classList.remove('scrolled');
		}
	});

	const lightbox = GLightbox({
		selector: '.glightbox'
	});
	/*
		const parallaxImage = document.querySelector(".parallax-image");
	
		window.addEventListener("scroll", function () {
			let scrollTop = window.scrollY;
			let speed = -0.3; // Ajusta la velocidad del efecto
			parallaxImage.style.transform = `translateY(${scrollTop * speed}px)`;
		});
	*/
	const searchIcon = document.querySelector(".search-icon");
	const searchWrapper = document.querySelector(".search-wrapper");
	const searchInput = searchWrapper.querySelector(".search-input");

	searchIcon.addEventListener("click", function () {
		searchWrapper.classList.toggle("active");

		if (searchWrapper.classList.contains("active")) {
			setTimeout(() => {
				searchInput.focus();
			}, 300); // Un pequeño retraso para que la animación no interfiera con el autofocus
		}
	});

	document.addEventListener("click", function (event) {
		if (!searchWrapper.contains(event.target) && !searchIcon.contains(event.target)) {
			searchWrapper.classList.remove("active");
		}
	});



});






jQuery(document).ready(function ($) {
	$("#mobile-menu-toggle").click(function () {
		var $mobileMenu = $("#mobile-navbar");

		if ($mobileMenu.is(":visible")) {
			$mobileMenu.slideUp(400, function () {
				$mobileMenu.css("opacity", "0");
			});
		} else {
			$mobileMenu.css("opacity", "1").slideDown(400);
		}
	});

});


jQuery(document).ready(function ($) {
	$('#newsletter-form').submit(function (e) {
		e.preventDefault(); // Evita la recàrrega de la pàgina

		var email = $('#newsletter-email').val();

		$.ajax({
			type: 'POST',
			url: newsletterAjax.ajaxurl, // Ara farà servir la URL correcta
			data: {
				action: 'enviar_newsletter_email',
				email: email
			},
			beforeSend: function () {
				$('#newsletter-message').html('Enviant...');
			},
			success: function (response) {
				if (response.success) {
					$('#newsletter-message').html('<span style="color:green;">' + response.data + '</span>');
					$('#newsletter-email').val('');
				} else {
					$('#newsletter-message').html('<span style="color:red;">Error en enviar el correu.</span>');
				}
			}
		});
	});
});
